<template>
  <div v-if="catastroData && listaInmuebles">
    <v-layout row>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-flex xs12 sm3>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Buscar"
                single-line
                hide-details
              >
              </v-text-field>
            </v-flex>
            <v-divider class="mx-2" inset vertical></v-divider>
            <v-flex xs12 sm6>
              <div class="text-xs-center">
                <v-chip>
                  <v-avatar class="blue white--text">{{
                    totalResidencial
                  }}</v-avatar>
                  Uso Residencial
                </v-chip>
                <v-chip
                  :color="
                    !listaUsuarios
                      ? 'grey'
                      : listaUsuarios.resumen.empadronados >=
                        totalResidencial / 2
                      ? 'green'
                      : 'red'
                  "
                  text-color="white"
                >
                  <v-avatar class="white grey--text">{{
                    listaUsuarios ? listaUsuarios.resumen.empadronados : "0"
                  }}</v-avatar>
                  Empadronados
                </v-chip>
                <v-chip>
                  <v-avatar class="blue lighten-4">{{
                    listaUsuarios ? listaUsuarios.resumen.volantes : "0"
                  }}</v-avatar>
                  Volantes
                </v-chip>
                <v-divider class="mx-2" inset vertical></v-divider>
                <v-chip color="brown darken-1" text-color="white">
                  <v-avatar class="brown darken-3">{{
                    listaUsuarios ? listaUsuarios.resumen.anexo3 : "0"
                  }}</v-avatar>
                  Anexo III
                </v-chip>
                <v-chip color="deep-orange darken-2" text-color="white">
                  <v-avatar class="deep-orange darken-4">{{
                    listaUsuarios
                      ? listaUsuarios.resumen.anexo4 > 0
                        ? `${listaUsuarios.resumen.anexo4Cumplimentado}/${
                            listaUsuarios.resumen.anexo4
                          }`
                        : "0"
                      : "0"
                  }}</v-avatar>
                  Anexo IV
                </v-chip>
              </div>

              <!-- <span>Inmuebles residenciales: {{totalResidencial}} | Empadronados: {{listaUsuarios ? listaUsuarios.resumen.empadronados : '0'}} | Volantes: {{listaUsuarios ? listaUsuarios.resumen.volantes : '0'}}</span> -->
            </v-flex>
            <v-spacer></v-spacer>

            <v-btn
              large
              :color="temaColor"
              @click="listaFilteredDialog = !listaFilteredDialog"
            >
              <v-badge color="purple">
                <span slot="badge" v-if="totalFiltros > 0">{{
                  totalFiltros
                }}</span>
                <span>Filtros</span>
              </v-badge>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-data-table
              rows-per-page-text="Resultados por página"
              v-model="selected"
              :headers="headers"
              :items="listaInmueblesFilter"
              :search="search"
              :pagination.sync="pagination"
              class="elevation-1"
            >
              <template slot="headerCell" slot-scope="props">
                <v-tooltip bottom>
                  <span slot="activator">
                    {{ props.header.text }}
                  </span>
                  <span>
                    {{ props.header.tip || props.header.text }}
                  </span>
                </v-tooltip>
              </template>
              <template slot="items" slot-scope="props">
                <td>{{ props.item.ref }}</td>
                <td class="text-xs-center">{{ props.item.data.uso }}</td>
                <td class="text-xs-left text-truncate">
                  {{ props.item.data.direccion }}
                </td>
                <template
                  v-if="props.item.data.uso.toLowerCase() === 'residencial'"
                >
                  <td class="text-xs-center">
                    {{
                      props.item.users
                        ? `${props.item.users.empadronados} / ${
                            props.item.users.numUsers
                          }`
                        : "0"
                    }}
                  </td>
                  <!-- Volante empadronamiento -->
                  <td class="text-xs-center">
                    <v-btn
                      :color="
                        props.item.users ? props.item.users.color : 'grey'
                      "
                    >
                      {{ props.item.users ? props.item.users.text : "?" }}
                    </v-btn>
                    <v-btn
                      :disabled="props.item.users.numUsers > 0"
                      icon
                      @click="uploadVolante(props.item.ref)"
                    >
                      <v-icon color="primary">
                        mdi-cloud-upload
                      </v-icon>
                    </v-btn>
                  </td>
                  <!-- Anexo 3 -->
                  <td class="text-xs-center">
                    <v-btn
                      :color="
                        props.item.users ? props.item.users.colorAnexo3 : 'grey'
                      "
                    >
                      {{ props.item.users ? props.item.users.txtAnexo3 : "?" }}
                    </v-btn>
                  </td>
                  <!-- Anexo 4 -->
                  <!-- <td v-if="controlAnexo4" class="text-xs-center"> -->
                  <td class="text-xs-center">
                    <v-btn
                      :color="
                        props.item.users ? props.item.users.colorAnexo4 : 'grey'
                      "
                    >
                      <v-icon
                        v-if="
                          props.item.users && props.item.users.iconDiscapacidad
                        "
                        left
                        class="white--text"
                        >{{ props.item.users.iconDiscapacidad }}</v-icon
                      >
                      {{ props.item.users ? props.item.users.txtAnexo4 : "?" }}
                      <v-icon
                        v-if="props.item.users && props.item.users.iconMayor65"
                        right
                        class="white--text"
                        >{{ props.item.users.iconMayor65 }}</v-icon
                      >
                    </v-btn>
                  </td>
                </template>
                <template v-else>
                  <td class="text-xs-center">-</td>
                  <td class="text-xs-center">-</td>
                  <td class="text-xs-center">-</td>
                  <td class="text-xs-center">-</td>
                </template>
                <td class="text-xs-right">
                  <a
                    v-if="props.item.ref"
                    class="btn btn-outline-primary btn-sm no-decoration"
                    role="button"
                    @click="editarInmueble(props.item.ref)"
                  >
                    <v-icon class="mr-2" color="primary">create</v-icon>
                  </a>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog v-if="listaInmueblesFilter" v-model="listaFilteredDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <div>
            <div class="headline">Configurar Filtros</div>
            <span class="grey--text"
              >{{ listaInmueblesFilter.length }} Registros coincidentes</span
            >
          </div>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-combobox
                  v-model="listaFilterOption.uso"
                  :items="listasFilterUsos"
                  label="Usos"
                  multiple
                >
                </v-combobox>
              </v-flex>
              <v-flex xs12>
                <v-combobox
                  v-model="listaFilterOption.volante"
                  :items="listasFilterVolante"
                  label="Volante"
                  multiple
                >
                </v-combobox>
              </v-flex>
              <v-flex xs12>
                <v-combobox
                  v-model="listaFilterOption.anexo3"
                  :items="listasFilterAnexo3"
                  label="Anexo III"
                  multiple
                >
                </v-combobox>
              </v-flex>
              <v-flex xs12>
                <v-combobox
                  v-model="listaFilterOption.anexo4"
                  :items="listasFilterAnexo4"
                  label="Anexo IV"
                  multiple
                >
                </v-combobox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat
            @click.native="listaFilteredDialog = false"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Editar Inmueble -->
    <v-dialog v-model="inmuebleDialog" max-width="500px">
      <v-card v-if="editandoInmueble">
        <v-toolbar card dark :color="temaColor">
          <v-toolbar-title>
            Editar Inmueble | {{ refEdit ? refEdit : "" }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="closeDialog">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-title>
          <div>
            <!-- <div class="headline">Editar Inmueble</div> -->
            <span class="grey--text">{{
              editandoInmueble ? editandoInmueble.refCat : ""
            }}</span>
          </div>
        </v-card-title>

        <v-card-text>
          <v-text-field label="Dirección" v-model="editandoInmueble.direccion">
          </v-text-field>
          <v-text-field label="Uso" v-model="editandoInmueble.uso">
          </v-text-field>
          <v-layout row justify-space-between>
            <v-flex xs3>
              <v-text-field
                suffix="m2"
                label="Superficie"
                v-model="editandoInmueble.superficie"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs3>
              <v-text-field
                suffix="%"
                label="Cuota"
                v-model="editandoInmueble.cuota"
              >
              </v-text-field>
            </v-flex>
            <v-flex xs3>
              <v-text-field
                suffix="Año"
                label="Antigüedad"
                v-model="editandoInmueble.year"
              >
              </v-text-field>
            </v-flex>
          </v-layout>
          <v-btn @click="buscaUsuario">Agregar Usuario</v-btn>
          <v-data-table
            rows-per-page-text="Resultados por página"
            :headers="usersHeaders"
            :items="catastroUsers"
            class="elevation-1"
          >
            <template slot="items" slot-scope="users">
              <td>{{ users.item.nombre || "-" }}</td>
              <td>{{ users.item.apellidos || "-" }}</td>
            </template>
            <template slot="no-data">
              <v-alert :value="true" color="info" icon="info">
                No existen documentos :(
              </v-alert>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- OCR -->
    <v-dialog v-model="ocrDialog" max-width="800px">
      <ocr :data="ocrData" v-on:closeDialog="ocrDialog = false"></ocr>
    </v-dialog>
  </div>
  <div v-else>
    <h1>Ningún dato que mostrar</h1>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import EditProp from "@/components/propietarios/Admin-propietarios-edit";
import { dbFB } from "@/components/firebase.js";
import Ocr from "@/components/ocr-padron";
export default {
  name: "admin-catastro",
  props: ["catastroSelect"],
  components: { Ocr, EditProp },
  data() {
    return {
      ocrDialog: false,
      ocrData: null,
      listaFilteredDialog: false,
      listaFilterOption: {
        uso: [],
        volante: [],
        anexo3: [],
        anexo4: []
      },
      search: "",
      pagination: {
        sortBy: "name"
      },
      selected: [],
      headers: [
        { text: "Ref", value: "ref", tip: "referencia inmueble" },
        { text: "Uso", align: "center", value: "data.uso" },
        {
          text: "Dirección",
          align: "left",
          sortable: true,
          value: "data.direccion"
        },
        {
          text: "Emp. / P-I",
          align: "center",
          value: "empadronados",
          tip: "Nº de empadronados / Nº de Propietarios o Inquilinos",
          sortable: false
        },
        {
          text: "Volante",
          align: "center",
          value: "volante",
          tip:
            '¿Tenemos el Volante? : N/A = No Aplica (No hay empadronados), "-" = Uso No Residencial',
          sortable: false
        },
        { text: "Anexo III", align: "center", value: "users.anexo3" },
        { text: "Anexo IV", align: "center", value: "users.anexo4" },
        { text: "Editar", align: "right", value: "name", sortable: false }
      ],
      editandoInmueble: null,
      inmuebleDialog: false,
      refEdit: null,
      usersHeaders: [
        { text: "Nombre", value: "nombre" },
        { text: "Apellidos", value: "apellidos" }
      ]
    };
  },
  mounted() {
    if (this.navegationControl.inmueblesList.pagination) {
      this.pagination = this.navegationControl.inmueblesList.pagination;
    } else {
      this.pagination.rowsPerPage = this.pagination.totalItems;
    }
    if (this.navegationControl.inmueblesList.filtros) {
      this.listaFilterOption = this.navegationControl.inmueblesList.filtros;
    }
    if (this.navegationControl.inmueblesList.search) {
      this.search = this.navegationControl.inmueblesList.search;
    }
  },
  watch: {
    listaInmuebles() {
      this.pagination.rowsPerPage = this.pagination.totalItems;
    },
    pagination(newPag, oldPag) {
      if (newPag !== oldPag) {
        this.navegationControl.inmueblesList.pagination = newPag;
      }
    },
    listaFilterOption(newFiltro, oldFiltro) {
      if (newFiltro !== oldFiltro) {
        this.navegationControl.inmueblesList.filtros = newFiltro;
      }
    },
    search(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.navegationControl.inmueblesList.search = newVal;
      }
    }
  },
  computed: {
    ...mapState(["navegationControl"]),
    totalFiltros() {
      let counter = 0;
      const keysFilter = Object.keys(this.listaFilterOption);
      for (const key of keysFilter) {
        counter += this.listaFilterOption[key].length;
      }
      return counter;
    },
    temaColor() {
      return this.$store.getters.getTemaColorAdminUI;
    },
    catastroData() {
      if (this.catastroSelect) {
        return this.$store.getters.getCatastroId(this.catastroSelect);
      }
      return null;
    },
    listaInmuebles() {
      if (this.catastroData) {
        return this.catastroData.inmuebles;
      }
      /* if (this.catastroSelect) {
                return this.$store.getters.getCatastroIdInmuebles(this.catastroSelect)
            } */
      return {};
    },
    listaInmueblesFilter() {
      let result = this.listaInmueblesArray;
      let usos = this.listaFilterOption.uso;
      let volante = this.listaFilterOption.volante;
      let anexo3 = this.listaFilterOption.anexo3;
      let anexo4 = this.listaFilterOption.anexo4;
      if (usos.length > 0) {
        result = result.filter(item => usos.indexOf(item.data.uso) > -1);
      }
      if (volante.length > 0) {
        result = result.filter(
          item =>
            volante.indexOf(item.users.text) > -1 ||
            (volante.indexOf("?") > -1 && !item.users)
        );
      }
      if (anexo3.length > 0) {
        result = result.filter(
          item =>
            anexo3.indexOf(item.users.txtAnexo3) > -1 ||
            (anexo3.indexOf("?") > -1 && !item.users)
        );
      }
      if (anexo4.length > 0) {
        result = result.filter(
          item =>
            anexo4.indexOf(item.users.txtAnexo4) > -1 ||
            (anexo4.indexOf("?") > -1 && !item.users)
        );
      }
      return result;
    },
    listaInmueblesArray() {
      // item.noSabeEmpadronado && !item.volante
      if (this.listaInmuebles) {
        return Object.keys(this.listaInmuebles).map(i => {
          return {
            data: this.listaInmuebles[i],
            ref: i,
            users:
              this.listaUsuarios && this.listaUsuarios[i]
                ? this.listaUsuarios[i]
                : false
          };
        });
      }
      return null;
    },
    listaUsuarios() {
      if (this.catastroData && this.catastroData.catastroUsers) {
        const lista = Object.keys(this.catastroData.catastroUsers);
        let result = {};
        result.resumen = {
          empadronados: 0,
          volantes: 0,
          mayores65: 0,
          discapacidad: 0,
          anexo3: 0,
          anexo4: 0,
          anexo4Cumplimentado: 0
        };
        for (const key of lista) {
          const item = this.catastroData.catastroUsers[key];
          const empadronados = item.filter(i => i.empadronado);
          const volantes = item.filter(i => i.volante);
          const propietarios = item.filter(i => i.tipo === "0");
          const padronStatusConocido = item.filter(
            i => i.padronStatusConocido && i.padronStatusConocido > 0
          );

          const users = item.map(i => i.id);
          let discapacidad = false;
          let mayor65 = false;
          let iconDiscapacidad = false;
          let iconMayor65 = false;
          for (const userId of users) {
            const especial = this.$store.getters.isMayor65OrDiscapacidad(
              userId
            );
            if (especial.mayor65 && !mayor65) {
              result.resumen.mayores65++;
              mayor65 = true;
              iconMayor65 = "mdi-timelapse";
            }
            if (especial.discapacidad && !discapacidad) {
              result.resumen.discapacidad++;
              discapacidad = true;
              iconDiscapacidad = "mdi-wheelchair-accessibility";
            }
          }

          const inmueble = this.catastroData.inmuebles[key];
          const anexo3 = inmueble.cumpleRequisitoEcon ? true : false;
          let colorAnexo3 = "red";
          let txtAnexo3 = "NO";
          if (anexo3) {
            result.resumen.anexo3++;
            colorAnexo3 = "green";
            txtAnexo3 = "SI";
          }
          let anexo4 = false;
          let colorAnexo4 = "red";
          let txtAnexo4 = "No";
          if (mayor65 || discapacidad) {
            result.resumen.anexo4++;
            colorAnexo4 = "blue";
            txtAnexo4 = "Falta";
            if (inmueble.anexo4) {
              result.resumen.anexo4Cumplimentado++;
              anexo4 = true;
              colorAnexo4 = "green";
              txtAnexo4 = "Si";
            }
          }

          let color = "yellow darken-3";
          let text = "?";

          // Se sabe el estado de empadronamiento de todos los propietarios/inquilinos
          if (
            padronStatusConocido &&
            padronStatusConocido.length === item.length
          ) {
            color = "red";
            text = "No";
          }
          // yellow darken-3

          if (empadronados.length > 0) {
            result.resumen.empadronados++;
            color = "blue";
            text = "Falta";
            if (volantes.length > 0) {
              result.resumen.volantes++;
              color = "green";
              text = "SI";
            }
            // color = volantes.length > 0 ? 'green' : 'red'
            // text = volantes.length > 0 ? 'SI' : 'NO'
          }
          // color = volantes.length > 0 ? 'green' : ''
          result[key] = {
            numUsers: item.length,
            empadronados: empadronados.length,
            volantes: volantes.length,
            propietarios: propietarios ? propietarios.length : 0,
            color: color,
            text: text,
            mayor65: mayor65,
            discapacidad: discapacidad,
            anexo3: anexo3,
            anexo4: anexo4,
            colorAnexo3: colorAnexo3,
            txtAnexo3: txtAnexo3,
            colorAnexo4: colorAnexo4,
            txtAnexo4: txtAnexo4,
            iconMayor65: iconMayor65,
            iconDiscapacidad: iconDiscapacidad
          };
        }
        return result;
      }
      return null;
    },
    totalResidencial() {
      return this.listaInmueblesArray
        ? this.listaInmueblesArray.filter(
            item => item.data.uso.toLowerCase() === "residencial"
          ).length
        : 0;
    },
    catastroUsers() {
      if (this.editandoInmueble) {
        if (
          this.catastroData.catastroUsers &&
          this.catastroData.catastroUsers[this.editandoInmueble.refCat]
        ) {
          return this.catastroData.catastroUsers[this.editandoInmueble.refCat];
        }
      }
      return [];
    },
    listasFilterUsos() {
      return this.listaInmueblesArray
        .map(item => item.data.uso)
        .filter(this.onlyUnique);
    },
    listasFilterVolante() {
      return this.listaInmueblesArray
        .map(item => item.users.text || "?")
        .filter(item => typeof item !== "undefined")
        .filter(this.onlyUnique);
    },
    listasFilterAnexo3() {
      return this.listaInmueblesArray
        .map(item => item.users.txtAnexo3 || "?")
        .filter(item => typeof item !== "undefined")
        .filter(this.onlyUnique);
    },
    listasFilterAnexo4() {
      return this.listaInmueblesArray
        .map(item => item.users.txtAnexo4 || "?")
        .filter(item => typeof item !== "undefined")
        .filter(this.onlyUnique);
    },
    controlAnexo4() {
      return this.navegationControl.expedienteEdit.documentos.obrasSeguridad;
    }
  },
  methods: {
    uploadVolante(ref) {
      // Extraer dirección de newCatastro
      dbFB
        .ref("newCatastro")
        .child(this.catastroSelect)
        .child("inmuebles")
        .child(ref)
        .once("value")
        .then(snapshot => {
          const valor = snapshot.val();
          this.ocrData = {
            ref: ref,
            refCatastral: this.catastroSelect,
            refCatastralCompleta:
              valor && valor.refCat
                ? valor.refCat
                : `${this.catastroSelect}${ref}`,
            direccion: {
              calle: valor ? valor.direccion || "" : "",
              provincia: this.navegationControl.expedienteEdit.provincia || "",
              localidad: this.navegationControl.expedienteEdit.localidad || "",
              cp: this.navegationControl.expedienteEdit.cp || ""
            }
          };
          this.ocrDialog = true;
        })
        .catch(err => {
          // eslint-disable-next-line
                    console.log(`error: ${err.message}`);
        });
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
    changeVolante(item) {
      // Revisar
      item.valante ? (item.volante = false) : (item.volante = true);
    },
    volante(item) {
      let result = {
        txt: "No",
        color: "red"
      };
      if (item.empadronado && item.volante) {
        result = {
          txt: "Si",
          color: "green"
        };
      }
      if (item.noSabeEmpadronado) {
        result = {
          txt: "-",
          color: "grey"
        };
      }
      return result;
    },
    buscaUsuario() {
      this.$router.push("/dashboard/usuarios/user?cat=123456");
    },
    closeDialog() {
      this.editandoInmueble = null;
      this.inmuebleDialog = false;
      this.refEdit = null;
    },
    editarInmueble(ref) {
      // this.refEdit = ref
      // this.editandoInmueble = this.listaInmuebles[ref]
      // this.inmuebleDialog = true
      this.$router.push(
        `/dashboard/inmuebles-detalle/${this.catastroSelect}/${ref}`
      );
      // this.catastroUsers = this.catastroData.catastroUsers ? this.catastroData.catastroUsers[]
      // this.catastroUsers = this.$store.getters.getCatastroUsers(this.editandoInmueble.refCat)
    }
  }
};
</script>

<style scoped>
div.inputCentrado > div > div.v-input__slot > div > input[type="text"] {
  text-align: center !important;
}
</style>
